<template>
  <div>
    <skeleton
        type="rect"
        :width="'100%'"
        :height="'200px'"
      />
   
      <section class="store-landing-featured-wrapper">
        <div class="container xl">
   
          <div class="columns mb0 is-mobile selected-store-info--header">
            <div class="column is-12-mobile is-12-tablet store-info">
              <div class="store-detail">
                <div><skeleton type="rect" :width="'100%'" :height="'60px'"/></div>
              </div>
            </div>
          </div>
   

          <div v-for="i in 3" class="mb-20" v-bind:key="'ske-cat-'+i">
            <div class="mb-20 columns">
                <div class="column">
                  <skeleton tag="div" type="rect" :width="'300px'" :height="'40px'"/>
                </div>
            </div>
            <div class="columns mb0 is-mobile is-multiline">
              <div class="column" v-for="i in itemPerCat" v-bind:key="'cat-item-' + i">
                <skeleton tag="div" type="rect" :width="'100%'" :height="'300px'"/>
              </div>
            </div>
            
          </div>
        </div>
      </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemPerCat: 5,
      itemWidth: 18,
    }
  },

  mounted() {
    window.addEventListener("resize", this.itemPerCartFunc);
    this.itemPerCartFunc();
  },
  
  destroyed() {
    window.removeEventListener("resize", this.itemPerCartFunc);
  },

  methods: {
    itemPerCartFunc() {
      if(window.innerWidth > 1024){
        this.itemPerCat = 5;
        this.itemWidth = 18;
      } else if(window.innerWidth > 991){
        this.itemPerCat = 4;
      } else if(window.innerWidth > 768){
        this.itemPerCat = 3;
      } else {
        this.itemPerCat = 2;
        this.itemWidth = 50;
      }
    },
  }
};
</script>
